<template>
    <ul class="data-list">
        <hh-data-item v-for="item in listItems"
                      :key="item[0]"
                      :item="item" />
    </ul>
</template>

<script>

import Conversions from '@/helpers/conversions'

export default {

    props: {
        items: {
            type: [ Object, Array, String, Number ],
            required: true,
        },
    },

    computed: {

        listItems() {
            return this.items ?
                Array.isArray(this.items)
                    ? this.items
                    : Conversions.convertToKeyValuePairs(this.items)
                : []
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\global\_hh-data-list.scss

.data-list {
    list-style: none;
    margin: 10px 0;
    padding: 0;
}

</style>
